import { useTranslation as useI18nTranslation } from 'react-i18next';
import { useI18n } from '../context/I18nContext';

export const useTranslation = () => {
  const { t } = useI18nTranslation();
  const { currentLanguage, changeLanguage } = useI18n();

  return {
    t,
    changeLanguage,
    currentLanguage,
  };
};
